import { h } from "preact";

import { getImageSize } from "utils/image";

import imageSpecs from "../../imageSpecs.json";

interface Props {
  alt: string;
  className?: string;
  src: string;
  size: keyof typeof imageSpecs.sizes;
}

export const Picture = (props: Props): JSX.Element => {
  // We don't have auto-resizing for gifs, so if the original image is a gif, we
  // just use that.
  if (isGif(props.src)) {
    return (
      <picture>
        <img
          src={props.src}
          alt={props.alt}
          class={props.className}
          loading="lazy"
        />
      </picture>
    );
  }

  return (
    <picture>
      {imageSpecs.formats.map((ext) => (
        <source key={ext} srcSet={getImageSize(props.src, props.size, ext)} />
      ))}
      <img
        data-zoom-src={getImageSize(props.src, "w1600", "jpg")}
        src={getImageSize(props.src, "w800", "jpg")}
        alt={props.alt}
        class={props.className}
      />
    </picture>
  );
};

function isGif(imageSrc: string) {
  return imageSrc.trim().toLowerCase().endsWith(".gif");
}
